/**
 * Formats FQN for Oracle queries. Converts DATABASE.SCHEMA.TABLE to SCHEMA.TABLE format.
 * For FQNs with 3+ parts, takes parts[1] and parts[2], ignoring the first part.
 *
 * @param fqn - Fully Qualified Name to format
 * @returns SCHEMA.TABLE format for Oracle, or empty string for invalid inputs
 *
 * @example
 * formatFqnForOracle('admin.HR.EMPLOYEES') // returns 'HR.EMPLOYEES'
 * formatFqnForOracle('HR.EMPLOYEES') // returns 'HR.EMPLOYEES'
 */
export function formatFqnForOracle(fqn: string): string {
  // Validate input
  if (!fqn || typeof fqn !== 'string') {
    return ''
  }

  // Handle empty string after trimming
  const trimmedFqn = fqn.trim()
  if (!trimmedFqn) {
    return ''
  }

  const parts = trimmedFqn.split('.')

  // Handle FQNs with empty parts (e.g., "schema..table")
  if (parts.some((part) => part === '')) {
    // Return original for malformed FQNs to avoid data corruption
    return trimmedFqn
  }

  // For Oracle, always use SCHEMA.TABLE format
  // If we have 3 or more parts, take parts[1] and parts[2] (ignoring the first part)
  if (parts.length >= 3) {
    return `${parts[1]}.${parts[2]}`
  }

  // For simple formats (schema.table or table), return as is
  if (parts.length <= 2) {
    return trimmedFqn
  }

  return trimmedFqn
}
